export enum SessionPreference {
  IN_PERSON = 'inPerson',
  VIDEO = 'video',
  NO_PREFERENCE = 'mix'
}
